import { useRef, useEffect } from 'react'

/* eslint-disable */
const useUpdateEffect = (callback, dependencies) => {
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
    } else {
      return callback()
    }

  }, dependencies)
}
/* eslint-enable */

export default useUpdateEffect
